import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { KazaplanDiaporamaModule } from '../kazaplan-diaporama/kazaplan-diaporama.module';
import { KazaplanFullscreenPopinComponent } from './kazaplan-fullscreen-popin/kazaplan-fullscreen-popin.component';
import { KazaplanFullscreenDiapoComponent } from './kazaplan-fullscreen-diapo/kazaplan-fullscreen-diapo.component';
import { KazaplanFullscreenSidebarMediasComponent } from './kazaplan-fullscreen-sidebar-medias';
import { KazaplanFullscreenComponent } from './kazaplan-fullscreen/kazaplan-fullscreen.component';

import { KazaplanSharedModule } from '../kazaplan.shared.module';
import { UtilsModule } from '../../../utils/utils.module';
import { NgLetModule } from '../../../utils/directives/ng-let/ng-let.module';
import { KazaplanFullscreenService } from './kazaplan-fullscreen.service';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { KzButtonModule } from '../../../kz-ui/ui/form/button/kz-button.module';
import { KzIconsModule } from '../../../kz-ui/ui/icon/kz-icons.module';

@NgModule({
  imports: [
    SharedModule,
    UtilsModule,
    NgLetModule,
    InfiniteScrollModule,
    KazaplanDiaporamaModule,
    KazaplanSharedModule,
    KzButtonModule,
    KzIconsModule,
  ],
  declarations: [
    KazaplanFullscreenPopinComponent,
    KazaplanFullscreenDiapoComponent,
    KazaplanFullscreenSidebarMediasComponent,
    KazaplanFullscreenComponent
  ],
  exports: [
    KazaplanFullscreenPopinComponent,
    KazaplanFullscreenComponent
  ],
  providers: [
    KazaplanFullscreenService
  ]
})
export class KazaplanFullscreenComponentsModule { }
